import PropTypes from 'prop-types';
import Presenter from 'utils/PropTypesPresenter';
import { formatMoney } from 'utils/currencyHelper';

export default new Presenter(
  {
    apr: PropTypes.string,
    estimatedTaxes: PropTypes.number,
    estimatedTotalMonthlyPayment: PropTypes.number,
    fiveYearsPrincipalPaid: PropTypes.number,
    fiveYearsTotal: PropTypes.number,
    interestRate: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    offeringId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    upfrontCharges: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    notes: PropTypes.string,
    title: PropTypes.number,
    titleAmt: PropTypes.number,
    appraisal: PropTypes.number,
    upFrontMI: PropTypes.number,
    otherFees: PropTypes.number,
    hazardIns: PropTypes.number,
    propTax: PropTypes.number,
    mIrate: PropTypes.number,
    assessments: PropTypes.number,
    pi: PropTypes.number,
    mi: PropTypes.number,
    propertyTaxVal: PropTypes.number,
    hazardInsuranceVal: PropTypes.number,
    homePrice: PropTypes.number,
    period: PropTypes.number,
    creditScore: PropTypes.number,
    loanAmount: PropTypes.number,
    ltv: PropTypes.number,
  },
  {
    formattedMoney(value) {
      if (Number.isNaN(value)) return value;
      return formatMoney(value);
    },
    formattedFiveYearsTotal(bidFormValues) {
      return this.formattedMoney(this.fiveYearsTotal(bidFormValues));
    },
    formattedFiveYearsPrincipalPaid(bidFormValues) {
      return this.formattedMoney(this.fiveYearsPrincipalPaid(bidFormValues));
    },
    formattedPi(bidFormValues) {
      return this.formattedMoney(this.pi(bidFormValues));
    },
    formattedMi(bidFormValues) {
      return this.formattedMoney(this.mi(bidFormValues));
    },
    formattedPiMi(bidFormValues) {
      return this.formattedMoney(this.pi(bidFormValues) + this.mi(bidFormValues));
    },
    formattedPropertyTaxVal(bidFormValues) {
      return this.formattedMoney(this.propertyTaxVal(bidFormValues));
    },
    formattedHazardInsuranceVal(bidFormValues) {
      return this.formattedMoney(this.hazardInsuranceVal(bidFormValues));
    },
    formattedAssessments(bidFormValues) {
      return this.formattedMoney(this.assessments(bidFormValues));
    },
    formattedEstimatedTaxes(bidFormValues) {
      return this.formattedMoney(this.estimatedTaxes(bidFormValues));
    },
    formattedEstimatedTotalMonthlyPayment(bidFormValues) {
      return this.formattedMoney(this.estimatedTotalMonthlyPayment(bidFormValues));
    },
  },
);



// WEBPACK FOOTER //
// ./src/presenters/BidFormValuesPresenter.js